(function () {
  function parseJSON(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cleanProductTitle(value) {
    return String(value || '')
      .replace(/\s*(?:[|\-\u2013\u2014]\s*)?(?:\((?:UPC|EAN)\)|(?:UPC|EAN))\s*$/i, '')
      .trim();
  }

  function normalizeReference(value) {
    return String(value || '')
      .trim()
      .replace(/^#/, '')
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  function normalizeMatchText(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function normalizeActionStatus(value) {
    return String(value || '')
      .trim()
      .replace(/[^a-z0-9]+/gi, '')
      .toLowerCase();
  }

  function getItemTitleKey(item) {
    return normalizeMatchText(item && (item.title || item.name || item.productTitle));
  }

  function itemMatchesReturnRequestProducts(item, products) {
    var summary = normalizeMatchText(products);
    var title = getItemTitleKey(item);

    return !!summary && !!title && summary.indexOf(title) !== -1;
  }

  function normalizePaymentStatus(value) {
    return normalizeReference(String(value || '').replace(/[_-]/g, ' '));
  }

  function isCompletedReturnShippingPaymentStatus(value) {
    var status = normalizePaymentStatus(value);
    return status === 'paid' || status === 'partiallyrefunded' || status === 'refunded';
  }

  function getReturnRequestStatusLabel(value) {
    var status = String(value || '').trim();
    if (normalizeActionStatus(status) === 'withdrawalinitiated') return 'Return requested';
    return status;
  }

  function normalizePaidReturnRequests(requests) {
    if (!Array.isArray(requests)) return [];

    return requests
      .map(function (request) {
        var paymentStatus = request && (request.paymentStatus || request.payment_status || request.financialStatus || request.financial_status || '');

        return {
          orderReference: request && (request.orderReference || request.originalOrderReference || request.returnRequest || request.order || ''),
          selectedProducts: request && (request.selectedProducts || request.products || ''),
          status: getReturnRequestStatusLabel(request && (request.status || request.returnRequestStatus)) || 'Return requested',
          paymentStatus: paymentStatus,
          paymentCompleted: request && request.paymentCompleted === true
        };
      })
      .filter(function (request) {
        return normalizeReference(request.orderReference) &&
          normalizeMatchText(request.selectedProducts) &&
          (request.paymentCompleted || isCompletedReturnShippingPaymentStatus(request.paymentStatus));
      });
  }

  function getOrderReferenceKeys(order) {
    return [
      order && order.id,
      order && order.name,
      order && order.orderNumber,
      order && order.number
    ].map(normalizeReference).filter(Boolean);
  }

  function mergeTextSummary(primary, secondary) {
    var values = [primary, secondary]
      .map(function (value) {
        return String(value || '').trim();
      })
      .filter(Boolean);

    return values.filter(function (value, index) {
      var key = normalizeMatchText(value);
      return key && values.map(normalizeMatchText).indexOf(key) === index;
    }).join(', ');
  }

  function getPaidReturnStateForOrder(order, paidReturnRequests) {
    var orderRefs = getOrderReferenceKeys(order);
    var products = '';
    var status = '';

    normalizePaidReturnRequests(paidReturnRequests).forEach(function (request) {
      var requestRef = normalizeReference(request.orderReference);
      if (!requestRef || orderRefs.indexOf(requestRef) === -1) return;

      products = mergeTextSummary(products, request.selectedProducts);
      if (!status && request.status) status = request.status;
    });

    return {
      products: products,
      status: status
    };
  }

  function isReturnShippingFeeOrder(order) {
    var items = order && Array.isArray(order.items) ? order.items : [];

    return items.some(function (item) {
      var label = [
        item.title,
        item.name,
        item.productTitle,
        item.variantTitle,
        item.sku
      ].filter(Boolean).join(' ').toLowerCase();

      return label.indexOf('return shipping fee') !== -1 || label.indexOf('return-shipping-fee') !== -1;
    });
  }

  function normalizeOrders(orders, paidReturnRequests) {
    if (!Array.isArray(orders)) return [];

    return orders
      .filter(function (order) {
        return order && (order.id || order.name || order.orderNumber);
      })
      .filter(function (order) {
        return !isReturnShippingFeeOrder(order);
      })
      .map(function (order, index) {
        var id = String(order.id || order.name || order.orderNumber || index);
        var items = Array.isArray(order.items) ? order.items : [];
        var returnRequestStatus = order.returnRequestStatus || order.return_request_status || '';
        var returnRequestProducts = order.returnRequestProducts || order.return_request_products || '';
        var paidReturnState = getPaidReturnStateForOrder(order, paidReturnRequests);

        returnRequestStatus = getReturnRequestStatusLabel(returnRequestStatus);
        returnRequestProducts = mergeTextSummary(returnRequestProducts, paidReturnState.products);
        if (!returnRequestStatus && paidReturnState.status) {
          returnRequestStatus = paidReturnState.status;
        }

        return {
          id: id,
          name: order.name || (order.orderNumber ? '#' + order.orderNumber : id),
          orderNumber: order.orderNumber || order.number || '',
          processedAt: order.processedAt || order.date || '',
          processedAtRaw: order.processedAtRaw || '',
          total: order.total || order.totalPrice || '',
          financialStatus: order.financialStatus || '',
          fulfillmentStatus: order.fulfillmentStatus || order.status || '',
          cancelled: !!(order.cancelled || order.canceled || order.cancelledAt || order.cancelled_at || order.canceledAt || order.canceled_at),
          cancelledAt: order.cancelledAt || order.cancelled_at || order.canceledAt || order.canceled_at || '',
          email: order.email || '',
          returnRequestStatus: returnRequestStatus,
          returnRequestProducts: returnRequestProducts,
          withdrawalEligible: order.withdrawalEligible,
          withdrawalMessage: order.withdrawalMessage || order.ineligibilityReason || '',
          items: items.map(function (item, itemIndex) {
            var itemId = String(item.id || item.lineItemId || item.sku || itemIndex);
            var qty = parseInt(item.returnableQuantity || item.quantity || 1, 10);

            if (!qty || qty < 1) qty = 1;

            var normalizedItem = {
              id: itemId,
              lineItemId: item.lineItemId || item.id || itemId,
              title: item.title || 'Order item',
              variantTitle: item.variantTitle || item.variant || '',
              sku: item.sku || '',
              quantity: parseInt(item.quantity || qty, 10) || qty,
              returnableQuantity: qty,
              unitPrice: parseFloat(item.unitPrice || item.price || 0) || 0,
              unitPriceMinor: parseFloat(item.unitPriceMinor || item.priceMinor || 0) || 0,
              currency: item.currency || order.currency || '',
              image: item.image || null
            };

            normalizedItem.withdrawalInitiated = !!(
              item.withdrawalInitiated ||
              item.returnRequestInitiated ||
              item.return_request_initiated ||
              itemMatchesReturnRequestProducts(normalizedItem, returnRequestProducts)
            );

            return normalizedItem;
          })
        };
      });
  }

  function findByDataItem(root, selector, itemId) {
    var nodes = root.querySelectorAll(selector);
    var id = String(itemId);

    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].getAttribute('data-item-id') === id) return nodes[i];
    }

    return null;
  }

  function withTimeout(ms) {
    if (!window.AbortController) {
      return { signal: undefined, clear: function () {} };
    }

    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, ms);

    return {
      signal: controller.signal,
      clear: function () {
        window.clearTimeout(timer);
      }
    };
  }

  function parseResponseJSON(response) {
    return response.text().then(function (text) {
      if (!text) return {};

      try {
        return JSON.parse(text);
      } catch (error) {
        return {};
      }
    });
  }

  function createRequestError(defaultMessage, response, data) {
    var errorMessage = defaultMessage || 'Request failed';

    if (data && (data.message || data.error)) {
      errorMessage = data.message || data.error;
    }

    var error = new Error(errorMessage);

    if (response) {
      error.status = response.status;
      error.statusText = response.statusText || '';
    }

    return error;
  }

  function setHidden(node, shouldHide) {
    if (!node) return;
    node.hidden = shouldHide;
  }

  function initWithdrawalForm(root) {
    if (!root || root.dataset.cpWithdrawalBound === 'true') return;
    root.dataset.cpWithdrawalBound = 'true';

    var lookupForm = root.querySelector('[data-cp-withdrawal-lookup-form]');
    var requestForm = root.querySelector('[data-cp-withdrawal-request-form]');
    var submitForm = root.querySelector('[data-cp-withdrawal-submit-form]');
    var orderInput = root.querySelector('[data-cp-order-reference]');
    var emailInput = root.querySelector('[data-cp-order-email]');
    var messageNode = root.querySelector('[data-cp-withdrawal-message]');
    var asideNode = root.querySelector('.cp-withdrawal__aside');
    var surfaceNode = root.querySelector('.cp-withdrawal__surface');
    var selectPanel = root.querySelector('[data-cp-step-panel="2"]');
    var ordersNode = root.querySelector('[data-cp-withdrawal-orders]');
    var itemsNode = root.querySelector('[data-cp-withdrawal-items]');
    var cancelHelperNode = root.querySelector('[data-cp-cancel-helper]');
    var backToLookupButton = root.querySelector('[data-cp-back-to-lookup]');
    var backToRequestButton = root.querySelector('[data-cp-back-to-request]');
    var startAgainButton = root.querySelector('[data-cp-start-again]');
    var lookupButton = root.querySelector('[data-cp-lookup-button]');
    var lookupButtonText = root.querySelector('[data-cp-lookup-button-text]');
    var nextStepButton = root.querySelector('[data-cp-next-step-button]');
    var nextStepButtonText = root.querySelector('[data-cp-next-step-button-text]');
    var submitButton = root.querySelector('[data-cp-submit-button]');
    var submitButtonText = root.querySelector('[data-cp-submit-button-text]');
    var contactFallbackForm = root.querySelector('.cp-withdrawal__contact-fallback');
    var reviewSummary = root.querySelector('[data-cp-review-summary]');
    var successPanel = root.querySelector('[data-cp-success-panel]');
    var successCopy = root.querySelector('[data-cp-success-copy]');
    var successReference = root.querySelector('[data-cp-success-reference]');
    var reasonInput = root.querySelector('[data-cp-withdrawal-reason]');
    var noteInput = root.querySelector('[data-cp-withdrawal-note]');
    var confirmInput = root.querySelector('[data-cp-withdrawal-confirm]');
    var paymentOptionInput = root.querySelector('[data-cp-payment-option]');
    var panels = root.querySelectorAll('[data-cp-step-panel]');
    var indicators = root.querySelectorAll('[data-cp-step-indicator]');
    var payload = parseJSON(root.querySelector('[data-cp-withdrawal-customer-orders]'), {
      customer: {},
      orders: []
    });
    var paidReturnRequests = normalizePaidReturnRequests(payload.paidReturnRequests);
    var accountOrders = normalizeOrders(payload.orders, paidReturnRequests);
    var customerLoggedIn = !!(payload.customer && payload.customer.loggedIn);
    var activeOrders = [];
    var selectedOrder = null;
    var lookupEndpoint = root.dataset.lookupEndpoint || '';
    var pendingRequestEndpoint = root.dataset.pendingRequestEndpoint || '';
    var submitEndpoint = root.dataset.submitEndpoint || '';
    var accountLoginUrl = root.dataset.accountLoginUrl || '/account/login';
    var accountRegisterUrl = root.dataset.accountRegisterUrl || '/account/register';
    var returnShippingFeeDisplay = root.dataset.returnShippingFeeDisplay || '$12';
    var returnShippingFeeCurrency = root.dataset.returnShippingFeeCurrency || 'USD';
    var returnShippingFeeProductHandle = root.dataset.returnShippingFeeProductHandle || 'return-shipping-fee';
    var returnShippingFeeVariantId = root.dataset.returnShippingFeeVariantId || '';
    var requestTimeout = parseInt(root.dataset.requestTimeout || '15000', 10);
    var withdrawalWindowDays = parseInt(root.dataset.withdrawalWindowDays || '14', 10);
    var returnWindowDays = 30;
    if (!withdrawalWindowDays || withdrawalWindowDays < 1) withdrawalWindowDays = 14;

    function getInitialStep() {
      return customerLoggedIn ? 2 : 1;
    }

    function syncSurfaceHeightToSidebar() {
      if (!asideNode || !surfaceNode) return;

      if (window.matchMedia && window.matchMedia('(max-width: 990px)').matches) {
        root.style.removeProperty('--cp-withdrawal-sidebar-height');
        surfaceNode.style.minHeight = '';
        return;
      }

      var sidebarHeight = Math.ceil(asideNode.getBoundingClientRect().height);
      if (!sidebarHeight) return;

      root.style.setProperty('--cp-withdrawal-sidebar-height', sidebarHeight + 'px');
      surfaceNode.style.minHeight = sidebarHeight + 'px';
    }

    function setAccountSelectResultsVisible(hasResults) {
      if (!selectPanel) return;
      selectPanel.classList.toggle('has-order-results', !!hasResults);
      if (!hasResults) {
        selectPanel.classList.remove('has-selected-order');
      }
    }

    function setAccountSelectOrderSelected(hasSelectedOrder) {
      if (!selectPanel) return;
      selectPanel.classList.toggle('has-selected-order', !!hasSelectedOrder);
    }

    var cancelHelperTextNode = root.querySelector('[data-cp-cancel-helper-text]');

    function setCancelHelperVisible(isVisible, actionType) {
      if (cancelHelperTextNode) {
        cancelHelperTextNode.textContent = actionType === 'cancel'
          ? 'All eligible products are selected. Deselect any items you do not want to cancel.'
          : 'All eligible products are selected. Deselect any items you do not want to return.';
      }

      setHidden(cancelHelperNode, !isVisible);
    }

    function setStep(step) {
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-cp-step-panel') !== String(step);
      });

      indicators.forEach(function (indicator) {
        var isActive = indicator.getAttribute('data-cp-step-indicator') === String(step);
        indicator.classList.toggle('is-active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'step');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
    }

    function showMessage(type, text) {
      if (!messageNode) return;
      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = text;
      messageNode.hidden = false;
    }

    function showMessageWithLink(type, text, linkText, linkUrl) {
      if (!messageNode) return;

      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = '';

      var textNode = document.createElement('span');
      textNode.textContent = text + ' ';
      messageNode.appendChild(textNode);

      if (linkText && linkUrl) {
        var link = document.createElement('a');
        link.className = 'cp-withdrawal__message-link';
        link.href = linkUrl;
        link.textContent = linkText;
        messageNode.appendChild(link);
      }

      messageNode.hidden = false;
    }

    function showMessageWithActions(type, text, actions) {
      if (!messageNode) return;

      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = '';

      var textNode = document.createElement('span');
      textNode.textContent = text;
      messageNode.appendChild(textNode);

      var validActions = Array.isArray(actions)
        ? actions.filter(function (action) {
            return action && action.text && action.url;
          })
        : [];

      if (validActions.length) {
        var actionsNode = document.createElement('span');
        actionsNode.className = 'cp-withdrawal__message-actions';

        validActions.forEach(function (action) {
          var link = document.createElement('a');
          link.className = 'cp-withdrawal__message-action' + (action.primary ? ' is-primary' : '');
          link.href = action.url;
          link.textContent = action.text;
          actionsNode.appendChild(link);
        });

        messageNode.appendChild(actionsNode);
      }

      messageNode.hidden = false;
    }

    function getGuestAccountActions() {
      return [
        {
          text: 'Log in',
          url: accountLoginUrl,
          primary: true
        },
        {
          text: 'Create account',
          url: accountRegisterUrl
        }
      ];
    }

    function renderAccountOrdersList() {
      if (!accountOrders.length) {
        if (ordersNode) {
          ordersNode.innerHTML = '<div class="cp-withdrawal__message is-info">No orders are available to cancel or return yet.</div>';
        }
        setAccountSelectResultsVisible(false);
        clearMessage();
        return;
      }
      renderOrders(accountOrders);
    }

    function showAccountOrders() {
      clearMessage();
      setStep(2);
      renderAccountOrdersList();
    }

    function clearMessage() {
      if (!messageNode) return;
      messageNode.textContent = '';
      messageNode.hidden = true;
      messageNode.className = 'cp-withdrawal__message';
    }

    function setLookupBusy(isBusy) {
      if (lookupButton) lookupButton.disabled = isBusy;
      if (lookupButtonText) lookupButtonText.textContent = isBusy ? 'Loading...' : 'View orders';
    }

    function setSubmitBusy(isBusy) {
      if (submitButton) submitButton.disabled = isBusy;
      if (submitButtonText) {
        submitButtonText.textContent = isBusy ? 'Preparing payment...' : 'Continue to payment';
      }
    }

    function setNextStepBusy(isBusy) {
      if (nextStepButton) nextStepButton.disabled = isBusy;
      if (nextStepButtonText) nextStepButtonText.textContent = isBusy ? 'Checking...' : 'Next step';
    }

    function getDateOnly(value) {
      var raw = String(value || '').trim();
      var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      var parsed;

      if (match) {
        parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      } else if (raw) {
        parsed = new Date(raw);
      }

      if (!parsed || Number.isNaN(parsed.getTime())) return null;
      return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    function getOrderAgeDays(order) {
      var orderDate = getDateOnly(order.processedAtRaw || order.processedAt);
      if (!orderDate) return null;

      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.floor((today.getTime() - orderDate.getTime()) / 86400000);
    }

    function getOrderStatusText(order) {
      return String(order && (order.fulfillmentStatus || order.status || '') || '').trim();
    }

    function isCancelledOrder(order) {
      var status = normalizeActionStatus([
        getOrderStatusText(order),
        order && order.financialStatus
      ].filter(Boolean).join(' '));

      return !!(
        order &&
        (order.cancelled || order.cancelledAt || status === 'cx' || status.indexOf('cancel') !== -1 || status.indexOf('void') !== -1)
      );
    }

    function isUnfulfilledOrder(order) {
      var status = normalizeActionStatus(getOrderStatusText(order));
      return !status || status.indexOf('unfulfilled') !== -1;
    }

    function getOrderFlow(order) {
      if (!order) {
        return {
          action: 'return',
          eligible: true,
          message: '',
          optionLabel: 'Return',
          statusLabel: 'Order'
        };
      }

      var statusLabel = getOrderStatusText(order) || 'Order';

      if (isCancelledOrder(order)) {
        return {
          action: 'none',
          eligible: false,
          message: 'No cancellation or return options are available for cancelled orders.',
          optionLabel: '',
          statusLabel: 'Cancelled'
        };
      }

      if (isUnfulfilledOrder(order)) {
        return {
          action: 'cancel',
          eligible: true,
          message: '',
          optionLabel: 'Cancel order',
          statusLabel: statusLabel || 'Unfulfilled'
        };
      }

      var ageDays = getOrderAgeDays(order);
      if (ageDays !== null && ageDays > returnWindowDays) {
        return {
          action: 'none',
          eligible: false,
          message: 'No return options are available after ' + returnWindowDays + ' days.',
          optionLabel: 'Not available',
          statusLabel: statusLabel
        };
      }

      return {
        action: 'return',
        eligible: true,
        message: '',
        optionLabel: 'Return',
        statusLabel: statusLabel
      };
    }

    function getWithdrawalEligibility(order) {
      var flow = getOrderFlow(order);
      return {
        eligible: flow.eligible,
        message: flow.message
      };
    }

    function findLocalOrders(orderReference, email) {
      var ref = normalizeReference(orderReference);
      var normalizedEmail = String(email || '').trim().toLowerCase();

      return accountOrders.filter(function (order) {
        var refs = [order.id, order.name, order.orderNumber].map(normalizeReference);
        var emailMatches = !normalizedEmail || !order.email || String(order.email).toLowerCase() === normalizedEmail;
        return emailMatches && refs.indexOf(ref) !== -1;
      });
    }

    function getOrderSubtitle(order) {
      var parts = [];
      if (order.processedAt) parts.push(order.processedAt);
      if (order.total) parts.push(order.total);
      if (order.financialStatus) parts.push(order.financialStatus);
      return parts.join(' / ');
    }

    function renderOrders(orders) {
      activeOrders = normalizeOrders(orders, paidReturnRequests);
      selectedOrder = null;
      setHidden(requestForm, true);
      setCancelHelperVisible(false);
      setAccountSelectOrderSelected(false);

      if (!ordersNode) return;

      if (!activeOrders.length) {
        ordersNode.innerHTML = '<div class="cp-withdrawal__message is-info">No matching orders were found.</div>';
        setAccountSelectResultsVisible(false);
        return;
      }

      ordersNode.innerHTML = activeOrders
        .map(function (order) {
          var flow = getOrderFlow(order);
          var eligibility = {
            eligible: flow.eligible,
            message: flow.message
          };
          var hasInitiatedItem = Array.isArray(order.items) && order.items.some(function (item) {
            return !!item.withdrawalInitiated;
          });
          var hasSelectableItem = Array.isArray(order.items) && order.items.some(function (item) {
            return !item.withdrawalInitiated;
          });
          var isCancelled = isCancelledOrder(order);
          var status = flow.statusLabel || order.fulfillmentStatus || 'Order';
          var classes = 'cp-withdrawal-order' + (eligibility.eligible ? '' : ' is-disabled');
          var disabledAttr = eligibility.eligible ? '' : ' disabled aria-disabled="true"';
          var warning = eligibility.eligible
            ? ''
            : '<span class="cp-withdrawal-order__warning">' + escapeHTML(eligibility.message) + '</span>';
          var orderRadio = eligibility.eligible
            ? '<span class="cp-withdrawal-order__radio" aria-hidden="true"></span>'
            : '<span class="cp-withdrawal-order__radio-spacer" aria-hidden="true"></span>';
          var orderOption = '';

          if (eligibility.eligible && hasInitiatedItem) {
            status = order.returnRequestStatus || 'Return requested';
          }

          if (eligibility.eligible && hasSelectableItem && flow.action === 'cancel') {
            orderOption = '<span class="cp-withdrawal-order__cancel" data-cp-cancel-order data-cp-select-full-order>Cancel order</span>';
          } else if (eligibility.eligible && hasSelectableItem && flow.action === 'return') {
            orderOption = '<span class="cp-withdrawal-order__option cp-withdrawal-order__option--return" data-cp-select-full-order>Return</span>';
          } else if (!eligibility.eligible && !isCancelled) {
            orderOption = '<span class="cp-withdrawal-order__option cp-withdrawal-order__option--none">Not available</span>';
          }

          return [
            '<button class="' + classes + '" type="button" data-cp-order-id="' + escapeHTML(order.id) + '"' + disabledAttr + '>',
            orderRadio,
            '<span class="cp-withdrawal-order__body">',
            '<span class="cp-withdrawal-order__title">' + escapeHTML(order.name) + '</span>',
            '<span class="cp-withdrawal-order__meta">' + escapeHTML(getOrderSubtitle(order)) + '</span>',
            warning,
            '</span>',
            '<span class="cp-withdrawal-order__side">',
            '<span class="cp-withdrawal-order__status">' + escapeHTML(status) + '</span>',
            orderOption,
            '</span>',
            '</button>'
          ].join('');
        })
        .join('');

      setAccountSelectResultsVisible(true);
      setStep(2);
    }

    function renderItems(order) {
      if (!itemsNode) return;

      if (!order.items.length) {
        itemsNode.innerHTML = '<div class="cp-withdrawal__message is-info">This order was found, but no product line items were available to show. Customer support can still verify the order after submission.</div>';
        return;
      }

      itemsNode.innerHTML = order.items
        .map(function (item) {
          var max = item.returnableQuantity || item.quantity || 1;
          var isInitiated = !!item.withdrawalInitiated;
          var selectControl = isInitiated
            ? '<span class="cp-withdrawal-item__select-spacer" aria-hidden="true"></span>'
            : '<input type="checkbox" data-cp-item-select data-item-id="' + escapeHTML(item.id) + '">';
          var quantityControl = '<span class="cp-withdrawal-item__qty-value" data-cp-item-qty-value data-item-id="' + escapeHTML(item.id) + '">' + escapeHTML(max) + '</span>';
          var meta = [];
          if (item.variantTitle && item.variantTitle !== 'Default Title') meta.push(item.variantTitle);
          if (item.sku) meta.push('SKU ' + item.sku);
          if (isInitiated) meta.push('Return requested');

          return [
            '<label class="cp-withdrawal-item' + (isInitiated ? ' is-withdrawal-initiated' : '') + '">',
            selectControl,
            item.image
              ? '<span class="cp-withdrawal-item__image"><img src="' + escapeHTML(item.image) + '" alt=""></span>'
              : '<span class="cp-withdrawal-item__placeholder" aria-hidden="true">CP</span>',
            '<span class="cp-withdrawal-item__body">',
            '<span class="cp-withdrawal-item__title">' + escapeHTML(cleanProductTitle(item.title)) + '</span>',
            isInitiated ? '<span class="cp-withdrawal-item__badge">Return requested</span>' : '',
            '<span class="cp-withdrawal-item__meta">' + escapeHTML(meta.join(' / ')) + '</span>',
            '</span>',
            '<span class="cp-withdrawal-item__qty">',
            '<span>Qty</span>',
            quantityControl,
            '</span>',
            '</label>'
          ].join('');
        })
        .join('');
    }

    function selectAllItemsForSelectedOrder() {
      if (!selectedOrder || !selectedOrder.items.length) return 0;

      var selectedCount = 0;

      selectedOrder.items.forEach(function (item) {
        if (item.withdrawalInitiated) return;

        var checkbox = findByDataItem(root, '[data-cp-item-select]', item.id);
        var qtyInput = findByDataItem(root, '[data-cp-item-qty]', item.id);
        var max = item.returnableQuantity || item.quantity || 1;

        if (checkbox && !checkbox.disabled) {
          checkbox.checked = true;
          selectedCount += 1;
        }

        if (qtyInput && !qtyInput.disabled) {
          qtyInput.value = max;
        }
      });

      return selectedCount;
    }

    function selectOrder(orderId, options) {
      var shouldSelectFullOrder = !!(options && options.selectFullOrder);

      selectedOrder = activeOrders.find(function (order) {
        return String(order.id) === String(orderId);
      });

      if (selectedOrder && !getWithdrawalEligibility(selectedOrder).eligible) {
        setHidden(requestForm, true);
        setAccountSelectOrderSelected(false);
        return;
      }

      root.querySelectorAll('.cp-withdrawal-order').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-cp-order-id') === String(orderId));
      });

      if (selectedOrder) {
        var selectedOrderFlow = getOrderFlow(selectedOrder);
        setCancelHelperVisible(false);
        renderItems(selectedOrder);
        if (shouldSelectFullOrder) {
          var selectedCount = selectAllItemsForSelectedOrder();
          if (selectedCount) {
            setCancelHelperVisible(true, selectedOrderFlow.action);
            showMessage('info', selectedOrderFlow.action === 'cancel'
              ? 'All available products have been selected to cancel this order.'
              : 'All available products have been selected for this return.');
          } else {
            showMessage('info', 'Return already requested for all products on this order.');
          }
        }
        setHidden(requestForm, false);
        setAccountSelectOrderSelected(true);
      } else {
        setAccountSelectOrderSelected(false);
      }
    }

    function fetchOrders(orderReference, email) {
      if (!lookupEndpoint) {
        return Promise.resolve([]);
      }

      var timeout = withTimeout(requestTimeout);

      return fetch(lookupEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        signal: timeout.signal,
        body: JSON.stringify({
          orderReference: orderReference,
          email: email,
          source: 'crep-protect-withdrawal-form'
        })
      })
        .then(function (response) {
          timeout.clear();
          return parseResponseJSON(response).then(function (data) {
            if (!response.ok) {
              throw createRequestError('Lookup failed', response, data);
            }

            return data;
          });
        })
        .then(function (data) {
          if (Array.isArray(data.orders)) return data.orders;
          if (data.order) return [data.order];
          return [];
        })
        .catch(function (error) {
          timeout.clear();
          throw error;
        });
    }

    function showLookupUnavailable(error) {
      var customer = payload.customer || {};
      var message = 'Please log in or create an account to view your order and complete your withdrawal.';
      var actions = [];

      if (error && (error.status === 401 || error.status === 403)) {
        message = 'Please log in or create an account to view your order and complete your withdrawal.';
      } else if (error && error.message && error.message !== 'Lookup failed') {
        message = error.message;
      }

      if (!customer.loggedIn) {
        message = 'Please log in or create an account to view your order and complete your withdrawal.';
        actions = getGuestAccountActions();
      }

      if (actions.length) {
        showMessageWithActions('error', message, actions);
        return;
      }

      showMessage('error', message);
    }

    function getSelectedItems() {
      if (!selectedOrder) return [];

      if (!selectedOrder.items.length) return [];

      return selectedOrder.items
        .filter(function (item) {
          if (item.withdrawalInitiated) return false;
          var checkbox = findByDataItem(root, '[data-cp-item-select]', item.id);
          return checkbox && checkbox.checked;
        })
        .map(function (item) {
          var qtyInput = findByDataItem(root, '[data-cp-item-qty]', item.id);
          var max = item.returnableQuantity || item.quantity || 1;
          var qty = qtyInput ? parseInt(qtyInput.value || max, 10) : max;

          if (!qty || qty < 1) qty = 1;
          if (qty > max) qty = max;

          return {
            id: item.id,
            lineItemId: item.lineItemId,
            title: item.title,
            variantTitle: item.variantTitle,
            sku: item.sku,
            quantity: qty,
            unitPrice: item.unitPrice || 0,
            unitPriceMinor: item.unitPriceMinor || 0,
            currency: item.currency || returnShippingFeeCurrency
          };
        });
    }

    function validateSelectedRequest() {
      if (!selectedOrder) {
        showMessage('error', 'Select the order you want to cancel or return.');
        return false;
      }

      var orderEligibility = getWithdrawalEligibility(selectedOrder);
      if (!orderEligibility.eligible) {
        showMessage('error', orderEligibility.message);
        return false;
      }

      if (selectedOrder.items.length && !getSelectedItems().length) {
        var allItemsInitiated = selectedOrder.items.every(function (item) {
          return !!item.withdrawalInitiated;
        });

        if (allItemsInitiated) {
          showMessage('info', 'Return already requested for all products on this order.');
          return false;
        }

        showMessage('error', 'Select at least one item from the order.');
        return false;
      }

      return true;
    }

    function validatePaymentOption() {
      if (paymentOptionInput && !paymentOptionInput.checked) {
        showMessage('error', 'Confirm the return shipping payment option.');
        paymentOptionInput.focus();
        return false;
      }

      return true;
    }

    function getReturnShippingFee() {
      return {
        required: true,
        amount: returnShippingFeeDisplay,
        currency: returnShippingFeeCurrency,
        variantId: returnShippingFeeVariantId
      };
    }

    function parseDisplayMoney(value) {
      var amount = parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(amount) ? amount : 0;
    }

    function getReturnShippingFeeAmount() {
      return parseDisplayMoney(returnShippingFeeDisplay) || 12;
    }

    function getSelectedItemsSubtotal() {
      return getSelectedItems().reduce(function (total, item) {
        var unitPrice = parseFloat(item.unitPrice || 0) || 0;
        var unitPriceMinor = parseFloat(item.unitPriceMinor || 0) || 0;
        var quantity = parseInt(item.quantity || 1, 10) || 1;

        if (unitPriceMinor > 0) {
          unitPrice = unitPriceMinor / 100;
        }

        return total + (unitPrice * quantity);
      }, 0);
    }

    function shouldDeductReturnShippingFromStoreCredit() {
      return getSelectedItemsSubtotal() > getReturnShippingFeeAmount();
    }

    function formatLocalMoney(amount) {
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: returnShippingFeeCurrency || 'USD'
        }).format(amount);
      } catch (error) {
        return '$' + (Math.round(amount * 100) / 100).toFixed(2);
      }
    }

    function renderReviewSummary() {
      if (!reviewSummary || !selectedOrder) return;

      var items = getSelectedItems();
      var productSummary = items.length
        ? items.map(function (item) {
            var name = cleanProductTitle(item.title) || 'Selected product';
            if (item.variantTitle && item.variantTitle !== 'Default Title') {
              name += ' / ' + item.variantTitle;
            }

            return '<span>' + escapeHTML(name) + '<em>Qty ' + escapeHTML(item.quantity || 1) + '</em></span>';
          }).join('')
        : '<span>Selected products will show here</span>';

      reviewSummary.innerHTML = [
        '<div class="cp-withdrawal-review__row"><span>Order</span><strong>' + escapeHTML(selectedOrder.name) + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Products selected</span><strong class="cp-withdrawal-review__products">' + productSummary + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Return shipping charge</span><strong>' + escapeHTML(returnShippingFeeDisplay) + '</strong></div>'
      ].join('');

      if (submitButtonText) {
        submitButtonText.textContent = 'Continue to payment';
      }
    }

    function buildRequestPayload() {
      var selectedItems = getSelectedItems();
      var selectedReason = reasonInput && reasonInput.selectedOptions.length ? reasonInput.selectedOptions[0] : null;
      var selectedReasonValue = reasonInput ? reasonInput.value : '';
      var selectedReasonLabel = selectedReasonValue && selectedReason ? selectedReason.textContent : '';
      var email = (emailInput ? emailInput.value.trim() : '') || selectedOrder.email || '';
      var orderFlow = getOrderFlow(selectedOrder);
      var requestedAction = orderFlow.action === 'cancel' ? 'cancel_request' : 'refund_request';

      return {
        source: 'crep-protect-theme-withdrawal-form',
        order: {
          id: selectedOrder.id,
          name: selectedOrder.name,
          orderNumber: selectedOrder.orderNumber,
          email: email
        },
        customer: payload.customer || {},
        items: selectedItems,
        reason: selectedReasonLabel,
        reasonCode: selectedReasonValue,
        reasonLabel: selectedReasonLabel,
        note: noteInput ? noteInput.value.trim() : '',
        returnShippingFee: getReturnShippingFee(),
        payment: {
          required: true,
          option: paymentOptionInput ? paymentOptionInput.value : 'return_shipping_fee',
          status: 'pending',
          nextStep: true
        },
        workflow: {
          target: 'shopify_order',
          requestedAction: requestedAction,
          dashboardStatus: orderFlow.action === 'cancel' ? 'cancellation_requested' : 'return_shipping_payment_pending',
          customerEmailEvent: orderFlow.action === 'cancel' ? 'cancellation_requested' : 'return_initiated'
        },
        lookupFallback: false,
        requestedAt: new Date().toISOString(),
        requestedAction: orderFlow.action === 'cancel' ? 'cancel_order_request' : 'refund_or_return_with_return_shipping_fee'
      };
    }

    function getNumericVariantId(value) {
      var raw = String(value || '').trim();
      var gidMatch = raw.match(/ProductVariant\/(\d+)/);

      if (gidMatch) return gidMatch[1];

      var numeric = raw.replace(/\D/g, '');
      return numeric || '';
    }

    function encodeBase64UrlJSON(value) {
      if (!window.btoa) return '';

      try {
        var json = JSON.stringify(value);
        var bytes = encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, function (match, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });

        return window.btoa(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      } catch (error) {
        return '';
      }
    }

    function getCheckoutItemLabel(item) {
      var label = item && item.title ? cleanProductTitle(item.title) : 'Selected product';
      var variantTitle = item && item.variantTitle ? String(item.variantTitle).trim() : '';
      var sku = item && item.sku ? String(item.sku).trim() : '';

      if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
        label += ' / ' + variantTitle;
      }

      if (sku) {
        label += ' / SKU ' + sku;
      }

      return label;
    }

    function getCheckoutItemSummary(items) {
      if (!Array.isArray(items) || !items.length) return '';

      return items
        .map(function (item) {
          return getCheckoutItemLabel(item) + ' x ' + (item.quantity || 1);
        })
        .join(', ');
    }

    function getCheckoutItemNoteLines(items) {
      if (!Array.isArray(items) || !items.length) return [];

      return items.map(function (item, index) {
        return (index + 1) + '. ' + getCheckoutItemLabel(item) + ' - Qty ' + (item.quantity || 1);
      });
    }

    function getCheckoutReturnItems(items) {
      if (!Array.isArray(items) || !items.length) return [];

      return items.map(function (item) {
        return {
          id: item && item.id ? String(item.id) : '',
          lineItemId: item && item.lineItemId ? String(item.lineItemId) : '',
          title: item && item.title ? cleanProductTitle(item.title) : '',
          variantTitle: item && item.variantTitle ? String(item.variantTitle) : '',
          sku: item && item.sku ? String(item.sku) : '',
          quantity: parseInt(item && item.quantity || 1, 10) || 1
        };
      });
    }

    function buildReturnShippingOrderNote(data, selectedProducts) {
      var order = data && data.order ? data.order : {};
      var reason = data && (data.reasonLabel || data.reason) ? (data.reasonLabel || data.reason) : '';
      var customerNote = data && data.note ? data.note : '';
      var requestedAt = data && data.requestedAt ? data.requestedAt : new Date().toISOString();
      var itemLines = getCheckoutItemNoteLines(data ? data.items : []);
      var note = [
        'Withdrawal requested - return shipping payment',
        'Original order: ' + (order.name || order.orderNumber || ''),
        'Customer email: ' + (order.email || ''),
        'Requested item(s):'
      ];

      if (itemLines.length) {
        note = note.concat(itemLines);
      } else if (selectedProducts) {
        note.push(selectedProducts);
      } else {
        note.push('No selected item details supplied');
      }

      note.push('Return shipping fee: ' + returnShippingFeeDisplay);
      if (reason) note.push('Reason: ' + reason);
      if (customerNote) note.push('Customer message: ' + customerNote);

      return note.join('\n');
    }

    function normalizeProductHandle(value) {
      return String(value || '')
        .trim()
        .replace(/^https?:\/\/[^/]+/i, '')
        .replace(/^\/?products\//, '')
        .replace(/\.js$/, '')
        .replace(/^\/+|\/+$/g, '');
    }

    function getProductVariantIds(product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];

      return variants
        .map(function (variant) {
          return variant && variant.available !== false ? getNumericVariantId(variant.id) : '';
        })
        .filter(Boolean);
    }

    function resolveReturnShippingVariantIds() {
      var fallbackVariantId = getNumericVariantId(returnShippingFeeVariantId);
      var productHandle = normalizeProductHandle(returnShippingFeeProductHandle || 'return-shipping-fee');

      if (!productHandle) {
        return fallbackVariantId
          ? Promise.resolve([fallbackVariantId])
          : Promise.reject(new Error('Missing return shipping product'));
      }

      return fetch('/products/' + encodeURIComponent(productHandle) + '.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(function (response) {
          return parseResponseJSON(response).then(function (data) {
            if (!response.ok) {
              throw createRequestError('Return shipping product lookup failed', response, data);
            }

            return data;
          });
        })
        .then(function (product) {
          var variantIds = getProductVariantIds(product);
          if (!variantIds.length) throw new Error('Return shipping product has no variants');
          return variantIds;
        })
        .catch(function (error) {
          if (fallbackVariantId) return [fallbackVariantId];
          throw error;
        });
    }

    function resolveReturnShippingVariantId() {
      return resolveReturnShippingVariantIds().then(function (variantIds) {
        if (variantIds.length) return variantIds[0];
        throw new Error('Missing return shipping product');
      });
    }

    function getReturnShippingCheckoutDetails(data, resolvedVariantId) {
      var variantId = getNumericVariantId(resolvedVariantId || returnShippingFeeVariantId);
      if (!variantId) return null;

      var order = data && data.order ? data.order : {};
      var reason = data && (data.reasonLabel || data.reason) ? (data.reasonLabel || data.reason) : '';
      var reasonCode = data && data.reasonCode ? data.reasonCode : '';
      var customerNote = data && data.note ? data.note : '';
      var requestedAt = data && data.requestedAt ? data.requestedAt : '';
      var selectedProducts = getCheckoutItemSummary(data ? data.items : []);
      var selectedReturnItems = JSON.stringify(getCheckoutReturnItems(data ? data.items : []));
      var note = buildReturnShippingOrderNote(data, selectedProducts);
      var properties = {
        'Withdrawal status': 'Payment pending',
        'Return request': order.name || order.orderNumber || '',
        'Return email': order.email || '',
        'Return shipping fee': returnShippingFeeDisplay,
        'Selected products': selectedProducts,
        '_Selected return items': selectedReturnItems,
        'Return reason': reason,
        '_Return reason code': reasonCode,
        'Return note': customerNote,
        '_Return requested at': requestedAt
      };
      var attributes = {
        'Withdrawal status': 'Payment pending',
        'Withdrawal requested items': selectedProducts,
        'Return request': order.name || order.orderNumber || '',
        'Return email': order.email || '',
        'Return shipping fee': returnShippingFeeDisplay,
        'Selected products': selectedProducts,
        'Selected return items': selectedReturnItems,
        'Return reason': reason,
        'Return reason code': reasonCode,
        'Return note': customerNote,
        'Return requested at': requestedAt
      };

      return {
        variantId: variantId,
        order: order,
        note: note,
        properties: properties,
        attributes: attributes
      };
    }

    function buildReturnShippingCheckoutUrl(data) {
      var details = getReturnShippingCheckoutDetails(data);
      if (!details) return '';

      var query = [];
      var encodedProperties = encodeBase64UrlJSON(details.properties);

      if (encodedProperties) query.push('properties=' + encodedProperties);
      query.push('checkout');
      if (details.order.email) {
        query.push(encodeURIComponent('checkout[email]') + '=' + encodeURIComponent(details.order.email));
      }

      Object.keys(details.attributes).forEach(function (key) {
        if (!details.attributes[key]) return;
        query.push(encodeURIComponent('attributes[' + key + ']') + '=' + encodeURIComponent(details.attributes[key]));
      });

      query.push('note=' + encodeURIComponent(details.note));

      return '/cart/' + encodeURIComponent(details.variantId) + ':1?' + query.join('&');
    }

    function buildCheckoutPageUrl(data) {
      var order = data && data.order ? data.order : {};
      var query = [];

      if (order.email) {
        query.push(encodeURIComponent('checkout[email]') + '=' + encodeURIComponent(order.email));
      }

      return query.length ? '/checkout?' + query.join('&') : '/checkout';
    }

    function parseCartMutationResponse(response) {
      return parseResponseJSON(response).then(function (data) {
        if (!response.ok) {
          throw createRequestError('Cart update failed', response, data);
        }

        return data;
      });
    }

    function clearReturnShippingCartItems(variantIds) {
      var resolvedVariantIds = Array.isArray(variantIds) && variantIds.length
        ? Promise.resolve(variantIds)
        : resolveReturnShippingVariantIds();

      return resolvedVariantIds.then(function (ids) {
        var updates = {};
        var idLookup = {};

        ids.forEach(function (id) {
          if (id) idLookup[id] = true;
        });

        if (!Object.keys(idLookup).length) return {};

        return fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        })
          .then(parseCartMutationResponse)
          .then(function (cart) {
            var hasReturnShippingItem = false;
            var items = cart && Array.isArray(cart.items) ? cart.items : [];

            items.forEach(function (item) {
              var variantId = getNumericVariantId(item && item.variant_id);
              if (!variantId || !idLookup[variantId]) return;
              updates[variantId] = 0;
              hasReturnShippingItem = true;
            });

            if (!hasReturnShippingItem) return {};

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                updates: updates,
                attributes: {
                  'Withdrawal status': '',
                  'Withdrawal requested items': '',
                  'Return request': '',
                  'Return email': '',
                  'Return shipping fee': '',
                  'Selected products': '',
                  'Selected return items': '',
                  'Return reason': '',
                  'Return reason code': '',
                  'Return note': '',
                  'Return requested at': ''
                },
                note: ''
              })
            }).then(parseCartMutationResponse);
          });
      });
    }

    function clearStaleReturnShippingCartItems() {
      return clearReturnShippingCartItems().catch(function () {
        return {};
      });
    }

    function prepareReturnShippingCheckout(data) {
      return resolveReturnShippingVariantIds()
        .then(function (variantIds) {
          var variantId = variantIds[0];
          if (!variantId) throw new Error('Missing return shipping product');

          return clearReturnShippingCartItems(variantIds).catch(function () {
            return {};
          }).then(function () {
            return variantId;
          });
        })
        .then(function (variantId) {
          var details = getReturnShippingCheckoutDetails(data, variantId);
          if (!details) throw new Error('Missing return shipping product');

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{
                id: details.variantId,
                quantity: 1,
                properties: details.properties
              }]
            })
          })
            .then(parseCartMutationResponse)
            .then(function () {
              return details;
            });
        })
        .then(function (details) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              attributes: details.attributes,
              note: details.note
            })
          }).then(parseCartMutationResponse).catch(function () {
            return {};
          });
        })
        .then(function () {
          return buildCheckoutPageUrl(data);
        });
    }

    function getPaymentRedirectUrl(response, data) {
      if (response) {
        var responseUrl = response.paymentUrl || response.payment_url || response.checkoutUrl || response.checkout_url || response.nextUrl || response.next_url || '';
        if (responseUrl) return responseUrl;
      }

      return buildReturnShippingCheckoutUrl(data);
    }

    function maybeRedirectToPayment(response, data) {
      var redirectUrl = getPaymentRedirectUrl(response, data);
      if (!redirectUrl) return false;

      window.location.href = redirectUrl;
      return true;
    }

    function showStoreCreditSuccess(response, requestPayload) {
      response = response || {};
      requestPayload = requestPayload || {};

      var storeCredit = response.storeCredit || {};
      var creditAmount = storeCredit.amount ? formatLocalMoney(parseDisplayMoney(storeCredit.amount)) : '';
      var shippingDeducted = storeCredit.shippingFeeDeducted
        ? formatLocalMoney(parseDisplayMoney(storeCredit.shippingFeeDeducted))
        : returnShippingFeeDisplay;

      setSubmitBusy(false);
      if (submitForm) submitForm.hidden = true;
      if (successPanel) successPanel.hidden = false;
      if (successCopy) {
        successCopy.textContent = creditAmount
          ? 'Your request has been received. The ' + shippingDeducted + ' return label fee was deducted from your refund and ' + creditAmount + ' was issued as store credit.'
          : 'Your request has been received. The return label fee was deducted from your refund and store credit was issued to your account.';
      }
      if (successReference) {
        successReference.textContent = response.order && response.order.name
          ? 'Original order: ' + response.order.name
          : 'Store credit processed';
        successReference.hidden = false;
      }
      clearMessage();
      setStep(3);
    }

    function getFallbackBody(data) {
      var order = data.order || {};
      var customer = data.customer || {};
      var fee = data.returnShippingFee || {};
      var items = Array.isArray(data.items) && data.items.length
        ? data.items.map(function (item) {
            return '- ' + cleanProductTitle(item.title) + (item.sku ? ' / SKU ' + item.sku : '') + ' / Qty ' + item.quantity;
          }).join('\n')
        : '- No line items were available in the storefront payload; support should verify order items manually.';

      return [
        'Withdrawal or return request',
        '',
        'Order: ' + (order.name || order.orderNumber || ''),
        'Order email: ' + (order.email || ''),
        'Logged-in customer: ' + (customer.email || 'No'),
        'Reason: ' + (data.reasonLabel || data.reason || 'Not provided'),
        'Message: ' + (data.note || 'Not provided'),
        'Return shipping fee: ' + (fee.amount || returnShippingFeeDisplay) + ' required',
        'Payment status: pending',
        'Lookup fallback: No',
        'Requested at: ' + (data.requestedAt || ''),
        '',
        'Items:',
        items
      ].join('\n');
    }

    function submitContactFallback(data) {
      var formData = contactFallbackForm ? new FormData(contactFallbackForm) : new FormData();
      var action = contactFallbackForm ? contactFallbackForm.getAttribute('action') || '/contact' : '/contact';
      var order = data.order || {};
      var email = order.email || '';

      if (!email) {
        return Promise.reject(new Error('Missing customer email for contact fallback'));
      }

      formData.set('form_type', 'contact');
      formData.set('utf8', '1');
      formData.set('contact[email]', email);
      formData.set('contact[Order ID]', order.name || order.orderNumber || '');
      formData.set('contact[tags]', 'withdrawal-return-request');
      formData.set('contact[body]', getFallbackBody(data));

      return fetch(action, {
        method: 'POST',
        headers: {
          Accept: 'text/html'
        },
        credentials: 'same-origin',
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Contact fallback failed');
        }

        return {
          status: 'support_received',
          contactFallback: true
        };
      });
    }

    function submitRequest(data, allowContactFallback) {
      if (!submitEndpoint) {
        if (allowContactFallback === false) {
          return Promise.reject(new Error('Withdrawal request endpoint is required for store credit.'));
        }
        return submitContactFallback(data);
      }

      var timeout = withTimeout(requestTimeout);

      return fetch(submitEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        signal: timeout.signal,
        body: JSON.stringify(data)
      })
        .then(function (response) {
          timeout.clear();
          return parseResponseJSON(response).then(function (data) {
            if (!response.ok) {
              throw createRequestError('Submit failed', response, data);
            }
            return data;
          });
        })
        .catch(function (error) {
          timeout.clear();
          if (allowContactFallback === false) {
            throw error;
          }
          return submitContactFallback(data);
        });
    }

    function recordPendingRequest(data) {
      if (!pendingRequestEndpoint) {
        return Promise.resolve({});
      }

      var timeout = withTimeout(Math.min(requestTimeout, 3000));

      return fetch(pendingRequestEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        keepalive: true,
        signal: timeout.signal,
        body: JSON.stringify(data)
      })
        .then(function (response) {
          timeout.clear();
          return parseResponseJSON(response).then(function (data) {
            if (!response.ok) {
              throw createRequestError('Pending request failed', response, data);
            }

            return data;
          });
        })
        .catch(function (error) {
          timeout.clear();
          if (window.console && window.console.warn) {
            window.console.warn('Withdrawal pending admin update failed', error);
          }
          return {};
        });
    }

    if (lookupForm) {
      lookupForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();

        var orderReference = orderInput ? orderInput.value.trim() : '';
        var email = emailInput ? emailInput.value.trim() : '';

        if (!orderReference || !email) {
          var customer = payload.customer || {};
          if (customer.loggedIn) {
            showMessage('info', 'Use your account orders to choose the product(s) you want to cancel or return.');
          } else {
            showMessageWithActions(
              'error',
              'Please log in or create an account to view your order and complete your withdrawal.',
              getGuestAccountActions()
            );
          }
          return;
        }

        setLookupBusy(true);

        var localOrders = findLocalOrders(orderReference, email);
        if (localOrders.length) {
          renderOrders(localOrders);
          setLookupBusy(false);
          return;
        }

        fetchOrders(orderReference, email)
          .then(function (remoteOrders) {
            var orders = normalizeOrders(remoteOrders, paidReturnRequests);

            if (!orders.length) {
              showMessage('error', 'No matching order was found. Check the order ID and email, then try again.');
              return;
            }

            renderOrders(orders);
          })
          .catch(function (error) {
            showLookupUnavailable(error);
          })
          .finally(function () {
            setLookupBusy(false);
          });
      });
    }

    if (customerLoggedIn) {
      showAccountOrders();
    }

    clearStaleReturnShippingCartItems();
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      setSubmitBusy(false);
      clearStaleReturnShippingCartItems();
    });

    syncSurfaceHeightToSidebar();
    window.requestAnimationFrame(syncSurfaceHeightToSidebar);
    window.addEventListener('resize', syncSurfaceHeightToSidebar);
    window.addEventListener('load', syncSurfaceHeightToSidebar);
    window.setTimeout(syncSurfaceHeightToSidebar, 250);

    if (backToLookupButton) {
      backToLookupButton.addEventListener('click', function () {
        clearMessage();
        setStep(1);
      });
    }

    if (backToRequestButton) {
      backToRequestButton.addEventListener('click', function () {
        clearMessage();
        setStep(2);
      });
    }

    if (ordersNode) {
      ordersNode.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cp-order-id]');
        if (!button) return;
        selectOrder(button.getAttribute('data-cp-order-id'), {
          selectFullOrder: !!event.target.closest('[data-cp-select-full-order]')
        });
      });
    }

    if (startAgainButton) {
      startAgainButton.addEventListener('click', function () {
        activeOrders = [];
        selectedOrder = null;
        setAccountSelectResultsVisible(false);
        if (ordersNode) ordersNode.innerHTML = '';
        if (itemsNode) itemsNode.innerHTML = '';
        setCancelHelperVisible(false);
        setHidden(requestForm, true);
        if (requestForm) requestForm.reset();
        if (submitForm) {
          submitForm.hidden = false;
          submitForm.reset();
        }
        if (successPanel) successPanel.hidden = true;
        if (reviewSummary) reviewSummary.innerHTML = '';
        if (reasonInput) reasonInput.value = '';
        if (noteInput) noteInput.value = '';
        if (successReference) {
          successReference.textContent = '';
          successReference.hidden = true;
        }
        clearMessage();
        if (customerLoggedIn) {
          showAccountOrders();
        } else {
          setStep(getInitialStep());
        }
      });
    }

    if (requestForm) {
      requestForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();
        setNextStepBusy(true);

        if (!validateSelectedRequest()) {
          setNextStepBusy(false);
          return;
        }

        renderReviewSummary();
        if (submitForm) submitForm.hidden = false;
        if (successPanel) successPanel.hidden = true;
        setStep(3);
        setNextStepBusy(false);

        if (paymentOptionInput) {
          paymentOptionInput.focus();
        }
      });
    }

    if (submitForm) {
      submitForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();

        if (!validateSelectedRequest()) return;

        if (!validatePaymentOption()) return;

        if (confirmInput && !confirmInput.checked) {
          showMessage('error', 'Confirm that you want to submit this withdrawal or return request and pay the return label fee.');
          confirmInput.focus();
          return;
        }

        var requestPayload = buildRequestPayload();
        var hasReturnShippingProduct = !!(
          normalizeProductHandle(returnShippingFeeProductHandle || 'return-shipping-fee') ||
          getNumericVariantId(returnShippingFeeVariantId)
        );

        setSubmitBusy(true);

        if (hasReturnShippingProduct) {
          recordPendingRequest(requestPayload)
            .then(function () {
              return prepareReturnShippingCheckout(requestPayload);
            })
            .then(function (checkoutUrl) {
              if (!checkoutUrl) return;
              window.location.href = checkoutUrl || '/checkout';
            })
            .catch(function (error) {
              showMessage('error', error && error.message ? error.message : 'We could not process this request. Please try again.');
              setSubmitBusy(false);
            });
          return;
        }

        submitRequest(requestPayload)
          .then(function (response) {
            response = response || {};
            if (maybeRedirectToPayment(response, requestPayload)) return;

            showMessage(
              'error',
              'Return shipping checkout is not configured. Add the return shipping fee variant ID or return a checkoutUrl from the order workflow.'
            );
          })
          .catch(function () {
            showMessage(
              'error',
              'Return shipping checkout is not configured. Add the return shipping fee variant ID or return a checkoutUrl from the order workflow.'
            );
          })
          .finally(function () {
            setSubmitBusy(false);
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  });
})();
